import React from 'react';

// components
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

// styles
import { CalloutContainer, CalloutTxt } from './PLPCallout.styles';

export type PLPCalloutProps = {
  calloutType: 'getStarted' | 'customize' | 'startWebsite';
};

const PLPCallout: React.FC<PLPCalloutProps> = ({ calloutType }) => {
  const handleClickCalloutBtn = () => {
    if (typeof window !== 'undefined') {
      window.location.assign('/wedding/onboard/wedding-website');
    }
  };

  const getCalloutTxt = (): JSX.Element => {
    switch (calloutType) {
      case 'getStarted':
        return (
          <>
            All the wow-factor, <span>zero design skills required</span>
          </>
        );
      case 'customize':
        return (
          <>
            Make it yours with <span>custom layouts</span>
          </>
        );
      default:
        return (
          <>
            Add <span>videos and photos</span>
          </>
        );
    }
  };

  const getBtnTxt = (): string => {
    switch (calloutType) {
      case 'getStarted':
        return 'Get started';
      case 'customize':
        return 'Explore designs';
      default:
        return 'Start your website';
    }
  };

  return (
    <CalloutContainer data-testid="PLPCallout" data-plpitem>
      <CalloutTxt>{getCalloutTxt()}</CalloutTxt>
      <ButtonV3 variant="primary" onClick={handleClickCalloutBtn}>
        {getBtnTxt()}
      </ButtonV3>
    </CalloutContainer>
  );
};
export default PLPCallout;
